// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productPriceAndActionsStyle } from "@synd/App/Components/Product/ProductPriceAndActions";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            max-width: 100%;
            height: fit-content;
        `,
    },
    availability: {
        css: css`
            margin-bottom: 8px;
            display: flex;
            &:has(.inventory-message:empty) {
                margin-bottom: 4px;
            }
            ${({ isTableView }: any) =>
                isTableView &&
                css`
                    min-height: 17px;
                    &:has(.inventory-message:empty) {
                        min-height: 22px;
                    }
                `}
        `,
    },
    price: {
        css: css`
            margin-bottom: 8px;
        `,
    },
    addToCartActions: {
        css: css`
            ${({ showDivider }: any) =>
                showDivider &&
                css`
                    border-top: 1px solid ${color("common.border")};
                    padding-top: 12px;
                    margin-top: 12px;
                `}

            &:has(span[data-test-selector^="notify"]) {
                flex-wrap: wrap;
            }
        `,
    },
};

productPriceAndActionsStyle.productAddToListStyles = {
    link: {
        css: css`
            margin-left: auto;
            &:disabled {
                && {
                    ${IconWrapper}, ${TypographyStyle} {
                        opacity: 0.5;
                        color: ${color("primary")};
                    }
                }
            }
        `,
    },
};

productPriceAndActionsStyle.productListProductImageStyles = {
    wrapper: {
        css: css`
            width: auto;
            min-width: 80px;
        `,
    },
    compareCheckbox: {
        css: css`
            padding-top: 0;
            margin: 0;
            span[role="checkbox"] + label {
                margin-left: 8px;
            }
        `,
    },
};
productPriceAndActionsStyle.productDetailsQtyBreakPricing = {
    css: css`
        width: 100%;
        padding-top: 12px;
        border-top: 1px solid ${color("common.border")};
        &:empty {
            display: none;
        }
        margin-bottom: 12px;
    `,
};

productPriceAndActionsStyle.prebookWrapper = {
    css: css`
        background: ${color("common.ui8")};
        border-radius: 8px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        margin-bottom: 12px;
    `,
};

productPriceAndActionsStyle.prebookLabel = {
    variant: "h6",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
productPriceAndActionsStyle.prebookMessage = {
    ...fontConfig.xSmall,
    css: css`
        font-style: italic;
    `,
};
productPriceAndActionsStyle.multipleSalesQtyMsg = {
    ...fontConfig.xSmall,
    css: css`
        font-style: italic;
        display: block;
        padding: 8px;
        background: ${color("common.ui8")};
        border-radius: 8px;
        display: block;
        margin-bottom: 12px;
    `,
};

productPriceAndActionsStyle.borderTop = {
    css: css`
        padding-top: 12px;
        border-top: 1px solid ${color("common.border")};
    `,
};

productPriceAndActionsStyle.variantsWrapper = {
    css: css`
        &:not(:empty) {
            padding-top: 12px;
            border-top: 1px solid ${color("common.border")};
            margin-top: 4px;
        }
    `,
};
